import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { debounceTime, distinctUntilChanged, filter, take } from 'rxjs/operators';

import { AutocompleteLead } from '../../core/models/lead-campaign';
import { LeadCampaignService } from '../lead-campaign.service';

@Component({
  selector: 'app-lead-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent implements OnInit {

  @Input() public id = 'lead';
  @Input() public data: FormGroup;
  @Input() public field = '';
  @Input() public campaignId: string;
  @Input() public participants: any[];
  @Input() public isError: boolean = false;
  @Output() public fieldUser = new EventEmitter<AutocompleteLead>();

  public requestAutocomplete = new FormControl();
  public list: AutocompleteLead [] = [];
  public innerData = '';
  public open = false;
  public loading: boolean = true;
  public error: boolean = false;
  public messageError: string = 'O corretor não foi adicionado, por favor selecione um corretor.';

  @HostListener('document:click', ['$event'])
  onClick(ev: Event) {
    if (this.open) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        if (!this.error) {
          this.error = true;
          this.messageError = 'O corretor não foi adicionado, por favor selecione novamente.';
          this.fieldUser.emit(null);
        }
        this.closeOptions();
      }
    }
  }

  constructor(private eRef: ElementRef, private service: LeadCampaignService) { }

  ngOnInit(): void {
    this.searchAutocomplete();
    
    setTimeout(() => {
      const valueField = this.field ? this.data.value[this.field] : this.data.value['user_name'];
      if (valueField) {
        this.requestAutocomplete.setValue(valueField);
      }
      this.loading = false;
    }, 1200)
  }

  public searchAutocomplete() {
    this.requestAutocomplete.valueChanges.pipe(
      debounceTime(600),
      filter((x: string) => x?.length >= 3 || !x?.length),
      distinctUntilChanged(),
    ).subscribe((auto: string) => this.requestList(auto));
  }

  public requestList(auto: string): void {
    if (auto?.length >= 3 && this.innerData !== auto) {
      this.error = false;
      this.loading = true;
      this.service.getParticipantsAutoComplete(auto).subscribe((result) => {
        this.list = result;
        this.open = true;
        this.loading = false;
        const user = result.find(
          person => person.matched_record.nickname === this.data.value[this.field]
        );
        if (user) {
          this.closeOptions();
          this.checkNewParticipant(user, true);
        }
      });
    } else {
      this.closeOptions();
      this.list = [];
    }
  }

  public newUser(data: AutocompleteLead): void {
    this.innerData = data.matched_record.nickname;
    this.fieldUser.emit(data);
    this.requestAutocomplete.setValue(data.matched_record.nickname);
    this.closeOptions();
  }

  closeOptions() {
    this.open = false;
  }

  public checkNewParticipant(participant: AutocompleteLead, loggedUser = false): void {
    const isNotDuplicated = !this.isParticipantDuplicated(participant);
    if (loggedUser || (!loggedUser && isNotDuplicated)) {
      this.service.realtorAlreadyParticipating(this.campaignId, participant.matched_record.id)
      .pipe(take(1))
      .subscribe(isParticipating => {
        if (isParticipating && isNotDuplicated) {
          this.error = true;
          this.messageError = `O corretor ${participant.matched_record.nickname} 
            (${participant.matched_record.name}) já está participando da campanha 
            do Lopes Leads para esse produto.`;
          this.fieldUser.emit(null);
          this.closeOptions();
        } else {
          this.error = false;
          this.newUser(participant);
        }
      });
    } else {
      this.error = true;
      this.messageError = `Este corretor já foi selecionado.`;
    }
  }

  public isParticipantDuplicated(participant: AutocompleteLead): boolean {
    return this.participants.find(
      part => part.user_nickname === participant.matched_record.nickname
      ) != undefined;
  }
}